export default __webpack_public_path__ + "media/images/onglettitre-580cb2130d3799d1b517a95937b6bf2d.png";